import React, { useCallback, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import sortBy from 'lodash/sortBy';
import last from 'lodash/last';
import { Flex, Header } from 'nallian-shared-ui/lib/components';
import legalDocumentsService from '../../services/legalDocuments/legalDocumentsService';
import LegalDocsForm from './LegalDocsForm';
import LegalDocsList from './LegalDocsList';

const LegalDivider = styled.div`
  min-height: 100%;
  background: rgba(0, 0, 0, 0.2);
  width: 1px;
  margin: 0 2rem;
`;

const LegalDocs = ({
  dispatchLegalDocumentsGet,
  legalDocumentsFetch,
  communityTag,
  communityId,
  readOnly = false,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (communityTag) dispatchLegalDocumentsGet(communityTag);
  }, [dispatchLegalDocumentsGet, communityTag]);

  const handleRefetch = useCallback(() => {
    if (communityTag) dispatchLegalDocumentsGet(communityTag);
  }, [dispatchLegalDocumentsGet, communityTag]);

  const latestRevision = useMemo(
    () => last(sortBy(legalDocumentsFetch.value || [], 'revision'))?.revision || 0,
    [legalDocumentsFetch.value]
  );

  return (
    <Flex fluid direction="column">
      <Header style={{ marginTop: '0' }} dividing>
        {t('legalDocuments')}
      </Header>
      <Flex fluid>
        <>
          {!readOnly && (
            <>
              <LegalDocsForm
                latestRevision={latestRevision}
                communityTag={communityTag}
                communityId={communityId}
                handleRefetch={handleRefetch}
                legalDocuments={legalDocumentsFetch.value}
              />
              <LegalDivider />
            </>
          )}
          <LegalDocsList
            loading={legalDocumentsFetch.pending}
            legalDocuments={legalDocumentsFetch.value}
          />
        </>
      </Flex>
    </Flex>
  );
};

LegalDocs.propTypes = {
  dispatchLegalDocumentsGet: PropTypes.func.isRequired,
  legalDocumentsFetch: PropTypes.object.isRequired,
  communityTag: PropTypes.string.isRequired,
  communityId: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
};

export default legalDocumentsService(LegalDocs);
